/**
 * Created by desheng.zhao on 2019/6/17.
 */
import { mapActions } from 'vuex';
export default {
  methods: {
    pushError(err){
      this.addError({
        page: this.$t(this.$router.currentRoute.meta.title),
        error: err
      });
    },
    ...mapActions(["addError"]),
  }
}


// WEBPACK FOOTER //
// ./src/mixin/error.js